import { navBarConfigActionType } from '../../actionTypes';

export default (action, actionPayload) => (dispatch) => {
  switch (action) {
    case navBarConfigActionType.SET_CONFIG:
      dispatch({
        type: navBarConfigActionType.SET_CONFIG,
        payload: {
          titleText: actionPayload.titleText,
          showBackBtn: actionPayload.showBackBtn,
          showDesktopNavMenu: actionPayload.showDesktopNavMenu,
          showDesktopSearchBar: actionPayload.showDesktopSearchBar,
          showMobileSearchIcon: actionPayload.showMobileSearchIcon,
        },
      });
      break;
    case navBarConfigActionType.RESET:
      dispatch({
        type: navBarConfigActionType.RESET,
        payload: {},
      });
      break;
    default:
      return null;
  }
};



// WEBPACK FOOTER //
// ./actions/navBarConfigAction/index.js